var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.68607 11.6664H0.198214V3.87734H2.68607V11.6664ZM1.4408 2.81484C0.645268 2.81484 0 2.17422 0 1.40078C5.6941e-09 1.02927 0.151799 0.672977 0.422002 0.410279C0.692205 0.147582 1.05868 0 1.4408 0C1.82293 0 2.1894 0.147582 2.45961 0.410279C2.72981 0.672977 2.88161 1.02927 2.88161 1.40078C2.88161 2.17422 2.23607 2.81484 1.4408 2.81484ZM11.9973 11.6664H9.51482V7.87474C9.51482 6.97109 9.49607 5.81224 8.22134 5.81224C6.92786 5.81224 6.72964 6.79401 6.72964 7.80963V11.6664H4.24446V3.87734H6.63054V4.93984H6.66536C6.9975 4.32786 7.80884 3.68203 9.01929 3.68203C11.5371 3.68203 12 5.29401 12 7.38776V11.6664H11.9973Z",
    fill: "#A5AEB5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.4033579b04ac385b82afc57a9bbc2f92.svg";
export { ForwardRef as ReactComponent };